import { render, staticRenderFns } from "./ModelCreation.vue?vue&type=template&id=322dede9&"
import script from "./ModelCreation.vue?vue&type=script&lang=js&"
export * from "./ModelCreation.vue?vue&type=script&lang=js&"
import style0 from "./ModelCreation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports